module.exports = __webpack_public_path__ + "img/2分钟应急响应.99586495.png";